import * as angular from "angular";

angular.module("sharedTheme", []).config(($mdThemingProvider: any) => {
    const green = $mdThemingProvider.extendPalette("green", {
        500: "#13b26c",
        300: "#13b26c", //notification number colour
        600: "#13b26c",
        800: "#13b26c",
        A100: "#13b26c",
        A200: "#13b26c",
        A300: "#13b26c",
        A400: "#13b26c",
        A500: "#13b26c",
        A600: "#13b26c",
        A700: "#13b26c",
        contrastDefaultColor: "light",
    });

    const orange = $mdThemingProvider.extendPalette("orange", {
        500: "#f59622",
        300: "#f59622", //notification number colour
        600: "#f59622",
        800: "#f59622",
        A100: "#f59622",
        A200: "#f59622",
        A300: "#f59622",
        A400: "#f59622",
        A500: "#f59622",
        A600: "#f59622",
        A700: "#f59622",
        contrastDefaultColor: "light",
    });

    $mdThemingProvider.definePalette("otherGreen", green);
    $mdThemingProvider.definePalette("otherOrange", orange);

    $mdThemingProvider.theme("green").primaryPalette("otherGreen");

    $mdThemingProvider.theme("new-orange").primaryPalette("otherOrange");

    $mdThemingProvider.definePalette("white", {
        50: "#000",
        100: "#000", //tab item non selected colour
        200: "#000", //body background colour
        300: "#000",
        400: "#000", //search box
        500: "#000",
        600: "#000", //select option selected
        700: "#000",
        800: "#000",
        900: "#000",
        A100: "#000",
        A200: "#000", //toolbar background color
        A300: "#000",
        A400: "#000",
        A700: "#000",
        contrastDefaultColor: "dark", // whether, by default, text (contrast)
    });

    $mdThemingProvider.definePalette("black", {
        50: "#000",
        100: "#000",
        200: "#000",
        300: "#000",
        400: "#000",
        500: "#000",
        600: "#000",
        700: "#000",
        800: "#000",
        900: "#000",
        A100: "#000",
        A200: "#000",
        A400: "#000",
        A700: "#000",
        contrastDefaultColor: "light",
    });

    $mdThemingProvider
        .theme("black")
        .primaryPalette("black")
        .accentPalette("white");
});
